import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    attrs: {
      "title": _vm.cardTitle,
      "size": "small",
      "bordered": false
    }
  }, [_c('template', {
    slot: "extra"
  }, [_c('a-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")]), _vm.$route.query.type != 3 ? _c('a-button', {
    style: {
      marginLeft: '8px'
    },
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.saveDraft
    }
  }, [_vm._v(" 保存 ")]) : _vm._e(), _vm.$route.query.type == 1 || _vm.$route.query.type == 2 || !_vm.$route.query.type ? _c('a-button', {
    style: {
      marginLeft: '8px'
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submitReimburse
    }
  }, [_vm._v(" 提交 ")]) : _vm._e()], 1), _c('a-form-model', {
    ref: "addForm",
    staticStyle: {
      "width": "100%",
      "overflow-x": "auto"
    },
    attrs: {
      "model": _vm.formObject.detail,
      "rules": _vm.rules,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "hideRequiredMark": true
    }
  }, [_c('a-row', [_c('div', {
    staticClass: "travel-title"
  }, [_c('strong', [_vm._v("差旅费用报销单")])])]), _c('div', {
    staticStyle: {
      "min-width": "1400px"
    }
  }, [_c('a-row', {
    staticClass: "single-head"
  }, [_c('a-col', {
    attrs: {
      "span": 6
    }
  }), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "所属组织及岗位",
      "prop": "organPostId",
      "rules": {
        type: 'array',
        required: _vm.organPostId.length === 0,
        message: '请选择所属组织及岗位',
        trigger: 'change'
      }
    }
  }, [_c('a-cascader', {
    style: {
      width: '100%'
    },
    attrs: {
      "suffix-icon": "　",
      "options": _vm.options,
      "show-search": {
        filterOption: _vm.filterOption
      },
      "placeholder": "请选择所属组织及岗位",
      "getPopupContainer": function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      }
    },
    on: {
      "change": _vm.onOrganAndJob
    },
    model: {
      value: _vm.organPostId,
      callback: function callback($$v) {
        _vm.organPostId = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "organPostId"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "label": "报销日期",
      "prop": "applyDate"
    }
  }, [_c('a-date-picker', {
    style: {
      width: '100%'
    },
    attrs: {
      "suffix-icon": "　",
      "placeholder": "请选择报销日期"
    },
    model: {
      value: _vm.formObject.detail.applyDate,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "applyDate", $$v);
      },
      expression: "formObject.detail.applyDate"
    }
  })], 1)], 1), _c('a-col', {
    attrs: {
      "span": 6
    }
  })], 1), _c('table', {
    staticClass: "single-table"
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "7%"
    }
  }), _c('col', {
    attrs: {
      "width": "7%"
    }
  }), _c('col', {
    attrs: {
      "width": "7%"
    }
  }), _c('col', {
    attrs: {
      "width": "7%"
    }
  }), _c('col', {
    attrs: {
      "width": "7%"
    }
  }), _c('col', {
    attrs: {
      "width": "7%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  }), _c('col', {
    attrs: {
      "width": "6%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', [_c('strong', [_vm._v("出差人")])]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.userInfo.userName))]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("出差事由")])]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "10"
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '0px'
    },
    attrs: {
      "prop": "reason",
      "wrapper-col": {
        span: 24
      }
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "max-length": 101,
      "placeholder": "请输入出差事由",
      "autocomplete": "off"
    },
    model: {
      value: _vm.formObject.detail.reason,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "reason", $$v);
      },
      expression: "formObject.detail.reason"
    }
  })], 1)], 1)]), _c('tr', [_c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("起点")])]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("终点")])]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("交通")])]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("出差补助")])]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("其他费用金额")])]), _c('td', {
    staticClass: "txt-center",
    attrs: {
      "rowspan": "2"
    }
  }, [_c('strong', [_vm._v("合计")])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("日期")])]), _c('td', [_c('strong', [_vm._v("地点")])]), _c('td', [_c('strong', [_vm._v("日期")])]), _c('td', [_c('strong', [_vm._v("地点")])]), _c('td', [_c('strong', [_vm._v("工具")])]), _c('td', [_c('strong', [_vm._v("金额")])]), _c('td', [_c('strong', [_vm._v("人数")])]), _c('td', [_c('strong', [_vm._v("天数")])]), _c('td', [_c('strong', [_vm._v("补助标准")])]), _c('td', [_c('strong', [_vm._v("金额")])]), _c('td', [_c('strong', [_vm._v("招待费")])]), _c('td', [_c('strong', [_vm._v("场地费")])]), _c('td', [_c('strong', [_vm._v("食宿费")])]), _c('td', [_c('strong', [_vm._v("保险费")])]), _c('td', [_c('strong', [_vm._v("其他费用")])])]), _vm._l(_vm.formObject.detail.matterList, function (item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "txt-input"
    }, [_c('a-date-picker', {
      attrs: {
        "suffix-icon": "　"
      },
      model: {
        value: item.startdate,
        callback: function callback($$v) {
          _vm.$set(item, "startdate", $$v);
        },
        expression: "item.startdate"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      attrs: {
        "autocomplete": "off"
      },
      model: {
        value: item.startplace,
        callback: function callback($$v) {
          _vm.$set(item, "startplace", $$v);
        },
        expression: "item.startplace"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-date-picker', {
      attrs: {
        "suffix-icon": "　",
        "disabledDate": _vm.disabledEnd(item)
      },
      model: {
        value: item.enddate,
        callback: function callback($$v) {
          _vm.$set(item, "enddate", $$v);
        },
        expression: "item.enddate"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      attrs: {
        "autocomplete": "off"
      },
      model: {
        value: item.endplace,
        callback: function callback($$v) {
          _vm.$set(item, "endplace", $$v);
        },
        expression: "item.endplace"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input', {
      directives: [{
        name: "emoji",
        rawName: "v-emoji"
      }],
      attrs: {
        "autocomplete": "off"
      },
      model: {
        value: item.traffictool,
        callback: function callback($$v) {
          _vm.$set(item, "traffictool", $$v);
        },
        expression: "item.traffictool"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      on: {
        "change": _vm.totalMoneyChange
      },
      model: {
        value: item.trafficmoney,
        callback: function callback($$v) {
          _vm.$set(item, "trafficmoney", $$v);
        },
        expression: "item.trafficmoney"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 0
      },
      on: {
        "change": _vm.totalMoneyChange
      },
      model: {
        value: item.peoplenum,
        callback: function callback($$v) {
          _vm.$set(item, "peoplenum", $$v);
        },
        expression: "item.peoplenum"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 1
      },
      on: {
        "change": _vm.totalMoneyChange
      },
      model: {
        value: item.daynum,
        callback: function callback($$v) {
          _vm.$set(item, "daynum", $$v);
        },
        expression: "item.daynum"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      on: {
        "change": _vm.totalMoneyChange
      },
      model: {
        value: item.subsidystandard,
        callback: function callback($$v) {
          _vm.$set(item, "subsidystandard", $$v);
        },
        expression: "item.subsidystandard"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      on: {
        "change": _vm.totalMoneyChange
      },
      model: {
        value: item.subsidymoney,
        callback: function callback($$v) {
          _vm.$set(item, "subsidymoney", $$v);
        },
        expression: "item.subsidymoney"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      on: {
        "change": _vm.totalMoneyChange
      },
      model: {
        value: item.servefee,
        callback: function callback($$v) {
          _vm.$set(item, "servefee", $$v);
        },
        expression: "item.servefee"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      on: {
        "change": _vm.totalMoneyChange
      },
      model: {
        value: item.sitefee,
        callback: function callback($$v) {
          _vm.$set(item, "sitefee", $$v);
        },
        expression: "item.sitefee"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      on: {
        "change": _vm.totalMoneyChange
      },
      model: {
        value: item.roomboardfee,
        callback: function callback($$v) {
          _vm.$set(item, "roomboardfee", $$v);
        },
        expression: "item.roomboardfee"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      on: {
        "change": _vm.totalMoneyChange
      },
      model: {
        value: item.insurancefee,
        callback: function callback($$v) {
          _vm.$set(item, "insurancefee", $$v);
        },
        expression: "item.insurancefee"
      }
    })], 1), _c('td', {
      staticClass: "txt-input"
    }, [_c('a-input-number', {
      style: {
        width: '100%'
      },
      attrs: {
        "min": 0,
        "max": 999999999,
        "precision": 2
      },
      on: {
        "change": _vm.totalMoneyChange
      },
      model: {
        value: item.waterfee,
        callback: function callback($$v) {
          _vm.$set(item, "waterfee", $$v);
        },
        expression: "item.waterfee"
      }
    })], 1), _c('td', {
      staticClass: "txt-input",
      style: {
        paddingLeft: '15px'
      }
    }, [_c('strong', {
      style: {
        minWidth: '80px',
        display: 'inline-block'
      }
    }, [_vm._v(_vm._s(item.mattertotal))])]), _c('a-popconfirm', {
      attrs: {
        "title": "确认删除该条记录？",
        "ok-text": "确认",
        "placement": "topLeft",
        "cancel-text": "取消"
      },
      on: {
        "confirm": function confirm($event) {
          return _vm.delMatter(item);
        }
      }
    }, [_c('a-icon', {
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "slot": "icon",
        "type": "question-circle-o"
      },
      slot: "icon"
    }), index > 0 ? _c('a-icon', {
      staticClass: "oper-icon",
      attrs: {
        "type": "minus-circle",
        "title": "删除"
      }
    }) : _vm._e()], 1), _vm.formObject.detail.matterList.length === index + 1 ? _c('a-icon', {
      staticClass: "oper-icon",
      attrs: {
        "type": "plus-circle",
        "title": "添加"
      },
      on: {
        "click": _vm.addMatter
      }
    }) : _vm._e()], 1);
  }), _c('tr', [_c('td', {
    staticClass: "txt-center",
    attrs: {
      "colspan": "5"
    }
  }, [_c('strong', [_vm._v("合计")])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.trafficMoney))])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.businessUser))])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.evectionDay))])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.evectionStandard))])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.evectionMoney))])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.entertainMoney))])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.fieldMoney))])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.foodMoney))])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.insuranceMoney))])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.waterMoney))])]), _c('td', {
    staticClass: "txt-input",
    style: {
      paddingLeft: '15px'
    }
  }, [_c('strong', {
    style: {
      display: 'inline-block'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.mattertotalMoney))])])]), _c('tr', [_c('td', [_c('strong', [_vm._v("报销总额")])]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("人民币（大写）：")]), _c('strong', {
    style: {
      color: 'red'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.totalAmountBig))])]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("￥：")]), _c('strong', {
    style: {
      color: 'red'
    }
  }, [_vm._v(_vm._s(_vm.formObject.detail.totalAmount))])]), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "4"
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '0px'
    },
    attrs: {
      "prop": "advanceFee",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      "label": "预支旅费"
    }
  }, [_c('a-input-number', {
    style: {
      width: '100%'
    },
    attrs: {
      "min": 0,
      "max": 999999999,
      "precision": 2
    },
    model: {
      value: _vm.formObject.detail.advanceFee,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "advanceFee", $$v);
      },
      expression: "formObject.detail.advanceFee"
    }
  })], 1)], 1), _c('td', {
    staticClass: "txt-input",
    attrs: {
      "colspan": "3"
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '0px'
    },
    attrs: {
      "prop": "payeeUser",
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      },
      "label": "领款人"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "max-length": 51,
      "autocomplete": "off"
    },
    model: {
      value: _vm.formObject.detail.payeeUser,
      callback: function callback($$v) {
        _vm.$set(_vm.formObject.detail, "payeeUser", $$v);
      },
      expression: "formObject.detail.payeeUser"
    }
  })], 1)], 1)]), _vm.$route.query.type == 3 ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "16"
    }
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("部门（年级）负责人：")]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("分管领导：")]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("财务审核：")])], 1), _c('br'), _c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("财务总监：")]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("校长：")]), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("理事长：")])], 1)], 1)]) : _vm._e()], 2)])], 1), _vm.$route.query.type != 3 ? _c('a-form-model-item', {
    staticStyle: {
      "margin-left": "26px"
    },
    attrs: {
      "label": "附件",
      "label-col": {
        span: 1
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-upload-dragger', {
    staticClass: "common-upload",
    attrs: {
      "name": "file",
      "accept": ".pdf,.doc,.docx,.jpg,.jpge,",
      "multiple": true,
      "customRequest": _vm.actionUpload,
      "before-upload": _vm.beforeUpload,
      "fileList": _vm.fileObj,
      "remove": _vm.delFile
    },
    model: {
      value: _vm.fileObj,
      callback: function callback($$v) {
        _vm.fileObj = $$v;
      },
      expression: "fileObj"
    }
  }, [_c('p', {
    staticClass: "ant-upload-drag-icon"
  }, [_c('a-icon', {
    attrs: {
      "type": "inbox"
    }
  })], 1), _c('p', {
    staticClass: "ant-upload-text"
  }, [_vm._v("单击此区域选择文件上传")]), _c('p', {
    staticClass: "ant-upload-hint"
  }, [_vm._v(" 允许多个上传。(支持doc、docx、jpge、jpg、pdf格式上传，最大上传500MB) ")])])], 1) : _vm._e(), _vm.$route.query.type == 3 ? _c('a-form-model-item', {
    staticStyle: {
      "margin-left": "26px"
    },
    attrs: {
      "label": "文件",
      "label-col": {
        span: 1
      },
      "wrapper-col": {
        span: 22
      }
    }
  }, [_c('a-list', {
    style: {
      width: '97.5%'
    },
    attrs: {
      "data-source": _vm.formObject.detail.attach,
      "bordered": true
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-list-item-meta', [_c('a', {
          staticStyle: {
            "color": "#c7a368"
          },
          attrs: {
            "slot": "title",
            "target": "blank",
            "href": "".concat(_vm.config.baseUrl, "noticePath").concat(item.filePath),
            "download": item.fileName
          },
          slot: "title"
        }, [_vm._v(" " + _vm._s(item.fileName) + " ")])]), _c('div', [_vm._v(_vm._s(item.createTime))])], 1);
      }
    }], null, false, 3914301722)
  })], 1) : _vm._e()], 1)], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };